import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IMyOskStudentAgreementVm } from '../my-osk-student-agreement-vm.model';
@Injectable({ providedIn: 'root' })
export class MyOskStudentAgreementsService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/MyOskStudentAgreements`;
  }
  get(studentGuid: string): Observable<IMyOskStudentAgreementVm[]> {
    const headers = this.createHeaders();
    let params = new HttpParams();
    if (studentGuid !== undefined && studentGuid !== null) {
      params = params.set('studentGuid', studentGuid.toString());
    }
    return this.http.get<IMyOskStudentAgreementVm[]>(this.baseUrl, { headers, params });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
